interface IIconMenuProps {
  className?: string;
}

export const IconMenu = ({ className }: IIconMenuProps) => (
  <svg className={className} viewBox="0 0 24 21" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 12.5C0 12.225 0.225 12 0.5 12H23.5C23.775 12 24 12.225 24 12.5V14.5C24 14.775 23.775 15 23.5 15H0.5C0.225 15 0 14.775 0 14.5V12.5ZM0 8.5C0 8.775 0.225 9 0.5 9H23.5C23.775 9 24 8.775 24 8.5V6.5C24 6.225 23.775 6 23.5 6H0.5C0.225 6 0 6.225 0 6.5V8.5ZM0 2.5C0 2.775 0.225 3 0.5 3H23.5C23.775 3 24 2.775 24 2.5V0.5C24 0.225 23.775 0 23.5 0H0.5C0.225 0 0 0.225 0 0.5V2.5ZM0 20.5C0 20.775 0.225 21 0.5 21H23.5C23.775 21 24 20.775 24 20.5V18.5C24 18.225 23.775 18 23.5 18H0.5C0.225 18 0 18.225 0 18.5V20.5Z" />
  </svg>
);
